/*viewed*/
function setCookie(cname,cvalue,exdays,samesite,path) {
  cvalue=encodeURIComponent(cvalue);
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires=" + d.toGMTString();
  if(samesite==='None'||samesite==='Strict'||samesite==='Lax'){
    if(path===''){
      document.cookie = cname + "=" + cvalue + ";" + expires + ";SameSite=" + samesite + "; Secure";
    }else{
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=" + path + ";SameSite=" + samesite + "; Secure";
    }
  }else{
    if(path===''){
      document.cookie = cname + "=" + cvalue + ";" + expires + ";SameSite=Lax";
    }else{
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=" + path + ";SameSite=Lax";
    }
  }
}
function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return decodeURIComponent(c.substring(name.length, c.length));
    }
  }
  return "";
}
$(document).ready(function(){
  if($("quantity-input").length){
    var pViewed=getCookie("product-viewed");
    var pHandle=$("quantity-input").attr("data-url");
    if(pViewed===""){
      setCookie("product-viewed",pHandle,365,"None","/");
    }else{
      var pViewedArray=pViewed.split(";");
      var i = 0;
      while (i < pViewedArray.length) {
        if (pViewedArray[i] === pHandle) {
          pViewedArray.splice(i, 1);
        } else {
          ++i;
        }
      }
      while(pViewedArray.length>11){
        pViewedArray.pop();
      }
      pViewed=pViewedArray.join(";");
      if(pViewed.trim()===""){
        pViewed=pHandle;
      }else{
        pViewed=pHandle+";"+pViewed;
      }
      setCookie("product-viewed",pViewed,365,"None","/");
    }
  }
  if($(".recently-viewed").length){
    var viewed=getCookie("product-viewed");
    if(viewed===""){
      $(".recently-viewed").parents("section:first").remove();
    }else{
      viewed=viewed.split(";");
      // $(".recently-viewed").find(".slider-counter--total:first").html(viewed.length);
      var updateViewed=false;
      $.each(viewed, function(key, value){
        try {
          var formdata = new FormData();
          formdata.append('file', "");
          $.ajax({
            url: window.location.origin + value + "?section_id=recently-get-viewed",
            // data: formdata,
            headers: {
              "Content-Type": "text/plain"
            },
            processData: false,
            contentType: false,
            type: 'GET',
            cache: false,
            success: function(result){
              const html = new DOMParser().parseFromString(result, 'text/html');
              const sourceQty = html.querySelector('li');
              $(".recently-viewed").find("ul:first").append(sourceQty.outerHTML);
              $(".recently-viewed").find("ul:first").find("li:last").attr("style", "--animation-order: "+key+";");
            }
          });
        //   fetch(window.location.origin + value + "?section_id=recently-get-viewed",
        //   {
        //     method: "GET",
        //     headers: {
        //         "Content-Type": "text/plain",
        //       "Connection": "close"
        //     }
        //   }).then((response) => response.text())
        //   .then((responseText) => {
        //     const html = new DOMParser().parseFromString(responseText, 'text/html');
        //     const sourceQty = html.querySelector('li');
        //     $(".recently-viewed").find("ul:first").append(sourceQty.outerHTML);
        //     $(".recently-viewed").find("ul:first").find("li:last").attr("style", "--animation-order: "+key+";");
        //   })
        //   .catch((e) => {
        //     console.error(e);
        //   });
        }catch (err) {
          updateViewed=true;
          viewed.splice(key, 1);
        }
      });
      if(updateViewed){
        viewed=viewed.join(";");
        setCookie("product-viewed",viewed,365,"None","/");
      }
    }
  }
});